import { useEffect, useMemo, useState } from "react";
import { PageDS, Spacer, TabMenu, ToastContainerDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { AdvancedAnalyticsVehiclesTab } from "./advancedAnalyticsVehiclesTab";
import { HistoryTab } from "./historyTab";
import {
  advancedAnalyticVehiclesByDepartmentAsync,
  selectAdvancedAnalyticsVehiclesListStatus,
} from "../../home/fleet/fleetSlice";
import { selectCurrentDepartment } from "../departments/departmentsSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

export const DepartmentFleet = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const firstPath = location.pathname.split("/")[1]; 
  const dispatch = useAppDispatch();
  const department = useAppSelector(selectCurrentDepartment);
  const advancedAnalyticVehiclesListStatus = useAppSelector(
    selectAdvancedAnalyticsVehiclesListStatus,
  );
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "advanced_analytics",
  );

  const tabs = useMemo(() => {
    return [
      {
        name: "advanced_analytics",
        title: t("fleet.tab.advanced_analytics"),
      },
      {
        name: "history",
        title: t("fleet.tab.tripsHistory"),
      },
    ];
  }, [t]);

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/${firstPath}/fleet/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [firstPath, navigate, params.id, selectedTab]);

  useEffect(() => {
    if (department && !department.hasAdvancedAnalytics) {
      navigate(`/${firstPath}`);
    }
  }, [department, navigate, firstPath]);

  useEffect(() => {
    if (department && advancedAnalyticVehiclesListStatus === "idle") {
      void dispatch(advancedAnalyticVehiclesByDepartmentAsync(department.uuid));
    }
  }, [dispatch, department, advancedAnalyticVehiclesListStatus]);

  return (
    <PageDS
      title={t(`fleet.title`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Spacer y={0.5} />
        </>
      }
      supportButton={{
        showMail: true,
      }}
    >
      <AdvancedAnalyticsVehiclesTab />
      <HistoryTab />
    </PageDS>
  );
};
